import moment from "moment";
import iconEdit from "../../../../../assests/editForm.png";
import MyTooltipComponent from "../../../ui/myTooltipComponent/MyTooltipComponent";
import { AccessibilityHiddenImg } from '@skillz/accessibility';
import classes from "./Templates.module.css";

import CalendarEventPopup from "../calendarEventPopup/CalendarEventPopup";

const WeekEventTemplate = (props) => {

    return (
        <MyTooltipComponent offsetX={100} offsetY={-10} Content={() => <CalendarEventPopup {...props} calendarType="FullCalendar" />} className={classes.DropHover}>
            <div className={classes.WeekEventWrapper}>
                <div className={`${classes.Event} ${classes.WeekEvent} ${props.IsAllDay && classes.WeekAllDayEvent} ${props.isAssessment ? classes.IsAssessment : null} ${props.holiday ? classes.Holiday : null}`}
                    style={{
                        borderColor: props.holiday ? "#53C8E1" : props.domainColor,
                        backgroundColor: props.holiday ? "#53C8E133" : props.IsAllDay ? `${props.DomainColor}33` : !props.IsAllDay && "white"
                    }} >
                    <div className={classes.DayWrapSubject}>
                        <div className={classes.Subject}>{props.Subject}</div>
                        {!props.IsAllDay && <>
                            <div className={classes.Time}>
                                {`${moment(props.EndTime).format('HH:mm')} - ${moment(props.StartTime).format('HH:mm')}`}
                            </div>
                            {/* <div className={classes.WeekEventLogo}></div> */}
                        </>}
                    </div>
                    {!props.IsAllDay && <div className={classes.WeekEventLogo} style={{ backgroundImage: `url(${props.ProviderLogo})` }} />}
                    {props.isAssessment && <AccessibilityHiddenImg className={classes.IconEdit} src={iconEdit} />}
                </div>
            </div>
        </MyTooltipComponent>
    )
}
export default WeekEventTemplate;